// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_40-2";
export var blackBorderOnHover = "_40-7";
export var cell = "_40-6";
export var cellContainer = "_40-3";
export var checked = "_40-8";
export var disabled = "_40-5";
export var featuredIconCellContainer = "_40-9";
export var featuredIconTextContainer = "_40-b";
export var featuredIconWrapper = "_40-a";
export var noBorder = "_40-c";
export var orangeSelectedRow = "_c6-3";
export var overflowableText = "_40-0";
export var overflowableTextContainer = "_40-1";
export var row = "_3z-0";
export var rowCheckboxCell = "_40-4";
export var selectableTable = "_c6-2";